import type { NotificationEntity } from "./notification.type";

export const isNotificationUnread = (notification: NotificationEntity) => {
  return notification.read_at === null;
};

export const isNotificationRead = (notification: NotificationEntity) => {
  return !isNotificationUnread(notification);
};
